import { storeName } from './types';

const getUserAddresses = state => state[storeName] || {};
const getStoredAddressId = state => getUserAddresses(state).storedAddressId || '';
const getDefaultAddressId = state => getUserAddresses(state).defaultAddressId || '';
const getAddresses = state => getUserAddresses(state).addresses || [];

export default {
    getAddresses,
    getStoredAddressId,
    getDefaultAddressId,
};
